import React from "react";
import "./styles.scss";
// import aboveIcon from "../../../assets/images/above-icon.svg";
// import bellowIcon from "../../../assets/images/bellow-icon.svg";

import { ReactComponent as UpDownIcon } from "../../../assets/images/up-down-icon.svg";
import { ReactComponent as UpDownIcon2 } from "../../../assets/images/up-down-icon_v1.svg";
import { useTheme } from "../../../hook/useThemes";

interface RoundItemProps {
  title?: string;
  up: number;
  down: number;
  index?: number;
}

export default function RoundItem(props: RoundItemProps) {
  const { title, up, down, index } = props;
  const { operatorId } = useTheme();

  const handleReturnWidth = (
    above: number,
    below: number,
    type: string
  ): string => {
    const total = above + below;

    if (type === "above") {
      const value = (above / total) * 100;
      return `${value}%`;
    }
    if (type === "below") {
      const value = (below / total) * 100;
      return `${value}%`;
    }
    return "0px";
  };

  const widthAbove = handleReturnWidth(up, down, "above");
  const widthBelow = handleReturnWidth(up, down, "below");

  return (
    <div
      className={`wrapper-content-round-item animate__animated animate__fadeInDown ${
        index === 0
          ? "animate-delay-02"
          : index === 1
          ? "animate-delay-03"
          : "animate-delay-04"
      }`}
    >
      <p className="title-round-item">{title}</p>
      <div className="content-round-item">
        {widthAbove !== "0%" && (
          <div
            className={`round-item round-above`}
            style={{
              width: widthAbove,
            }}
          >
            <p className="round-value">{up}</p>
            {/* <img src={aboveIcon} alt="aboveIcon" /> */}
            {operatorId === 2 ? <UpDownIcon2 /> : <UpDownIcon />}
          </div>
        )}
        {widthBelow !== "0%" && (
          <div
            className={`round-item round-below`}
            style={{
              width: widthBelow,
              minWidth: "10%",
            }}
          >
            <p className="round-value">{down}</p>
            {/* <img src={bellowIcon} alt="aboveIcon" /> */}
            {operatorId === 2 ? <UpDownIcon2 /> : <UpDownIcon />}
          </div>
        )}
      </div>
    </div>
  );
}
